'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface Feature {
	number: string
	title: string
	description: string
}

const features: Feature[] = [
	{
		number: '01',
		title: 'Подключаем к Сберу',
		description:
			'Создаём для вас персональное защищённое пространство в платёжном виджете и сами налаживаем связь между вашим пространством и Сбером.'
	},
	{
		number: '02',
		title: 'Настраиваем решение',
		description:
			'Устанавливаем платёжный сервис и включаем защиту, чтобы данные ваших клиентов были в полной безопасности.'
	},
	{
		number: '03',
		title: 'Тестируем',
		description:
			'Проводим финальную проверку всех функций и демонстрируем вам работу системы в реальных условиях с подробной инструкцией.'
	},
	{
		number: '04',
		title: 'Запускаем',
		description:
			'Передаём вам доступы от готового сервиса и остаёмся на связи, чтобы обеспечивать техническую поддержку и консультации.'
	}
]

const ReadySolution: React.FC = () => {
	return (
		<section className={styles.readySolution}>
			<div className={styles.content}>
				<AnimatedSection animation='slideUp'>
					<div className={styles.subtitle}>Готовое решение</div>
					<h2
						className={styles.title}
						dangerouslySetInnerHTML={{ __html: '<span>Запуск «под ключ»</span> — быстрое внедрение за несколько дней' }}
					/>
				</AnimatedSection>
				<AnimatedSection animation='slideUp'>
					<p
						className={styles.description}
						dangerouslySetInnerHTML={{
							__html: 'Вам не нужно тратить ресурсы своих разработчиков на интеграцию и изучение банковских API. Мы берём весь технический цикл на себя:'
						}}
					/>
				</AnimatedSection>

				<div className={styles.features}>
					{features.map((feature, index) => (
						<AnimatedSection key={index} animation='slideUp' className={styles.feature}>
							<div className={styles.featureHeader}>
								<div className={styles.featureNumber}>{feature.number}</div>
								<h3 className={styles.featureTitle}>{feature.title}</h3>
							</div>
							<div
								className={styles.featureDescription}
								dangerouslySetInnerHTML={{ __html: feature.description }}
							/>
						</AnimatedSection>
					))}
				</div>
			</div>
		</section>
	)
}

ReadySolution.displayName = 'ReadySolution'

export default ReadySolution
